import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { prettifyApiError } from "@/shared/api";
import { logout } from "@/features/auth/api";
import { IC_CLASS, RailButton, useFlash } from "./RailButton";

// Quanto resta a video il toast di errore.
const FEEDBACK_MS = 5000;

/**
 * Pulsante "Esci" del Rail in web-mode: termina la sessione applicativa
 * (POST /api/auth/logout → il backend cancella il cookie ``om_session``) e
 * porta alla pagina di login. Sul web sostituisce ``RailExitButton``: lì
 * "uscire" significa chiudere la sessione, non la finestra (che il browser
 * comunque non lascia chiudere da script). Stessa icona e stessa label di
 * ``RailExitButton``: per Davide è lo stesso gesto, cambia solo cosa chiude.
 * Feedback obbligatorio: spinner label durante la chiamata + toast in italiano
 * se il logout fallisce.
 */
export function RailLogoutButton({ compatto = false }: { compatto?: boolean }) {
  const navigate = useNavigate();
  const [busy, setBusy] = useState(false);
  const [feedback, flash] = useFlash<string>(FEEDBACK_MS);

  async function onLogout() {
    if (busy) return;
    setBusy(true);
    try {
      await logout();
      void navigate("/login", { replace: true });
    } catch (err) {
      flash(prettifyApiError(err));
    } finally {
      setBusy(false);
    }
  }

  return (
    <RailButton
      ariaLabel="Esci dalla sessione"
      label={busy ? "Esco…" : "Esci"}
      busy={busy}
      onClick={() => void onLogout()}
      icon={
        <svg className={IC_CLASS} viewBox="0 0 24 24" aria-hidden="true">
          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4M16 17l5-5-5-5M21 12H9" />
        </svg>
      }
      compatto={compatto}
      toast={feedback ? { tone: "error", text: feedback } : null}
    />
  );
}
